import { graphql, useStaticQuery } from 'gatsby';

export default () => {
  const { allStoryblokEntry } = useStaticQuery(graphql`
    query BlogTopicQuery {
      allStoryblokEntry(
        filter: { lang: { eq: "default" }, field_component: { in: [ "topic" ] } }
        sort: { fields: published_at, order: DESC }
      ) {
        nodes {
          uuid
          name
          full_slug
        }
      }
    }
  `);

  const topics = allStoryblokEntry.nodes;

  return [
    {
      uuid: 'all',
      name: 'All',
      full_slug: 'resources'
    },
    ...topics
  ];
};
